import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Alert from "@mui/material/Alert";

function LoginForm({ onLogin, error }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onLogin(username, password);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Stack spacing={2.5}>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField
          label="Brugernavn"
          name="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoComplete="username"
          required
          fullWidth
          variant="outlined"
          sx={{
            "& .MuiInputLabel-root": { color: "rgba(50, 38, 26, 0.85)" },
            "& .MuiOutlinedInput-root": {
              bgcolor: "rgba(255,255,255,0.35)",
              "& fieldset": { borderColor: "rgba(100, 80, 50, 0.45)" },
            },
          }}
        />
        <TextField
          label="Adgangskode"
          name="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
          fullWidth
          variant="outlined"
          sx={{
            "& .MuiInputLabel-root": { color: "rgba(50, 38, 26, 0.85)" },
            "& .MuiOutlinedInput-root": {
              bgcolor: "rgba(255,255,255,0.35)",
              "& fieldset": { borderColor: "rgba(100, 80, 50, 0.45)" },
            },
          }}
        />
        <Button type="submit" variant="contained" color="primary" size="large" fullWidth>
          Log ind
        </Button>
      </Stack>
    </form>
  );
}

export default LoginForm;
